var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 16.8943H11.9166L7.83741 19.6076C7.23241 20.0109 6.41659 19.5801 6.41659 18.8468V16.8943C3.66659 16.8943 1.83325 15.0609 1.83325 12.3109V6.81087C1.83325 4.06087 3.66659 2.22754 6.41659 2.22754H15.5833C18.3333 2.22754 20.1666 4.06087 20.1666 6.81087V12.3109C20.1666 15.0609 18.3333 16.8943 15.5833 16.8943Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 10.4131V10.2206C10.9999 9.59729 11.3849 9.26727 11.7699 9.00144C12.1458 8.74477 12.5216 8.41478 12.5216 7.80978C12.5216 6.96645 11.8432 6.28809 10.9999 6.28809C10.1566 6.28809 9.47827 6.96645 9.47827 7.80978",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.996 12.6038H11.0042",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.23c090836b3cd52949345a71a52b0f6a.svg";
export { ForwardRef as ReactComponent };